import { useMemo } from 'react'

import { ItemPermissionType } from '../enums/item'
import { Action } from '../enums/permission'

const permissionToActionsMap: Record<ItemPermissionType, Array<Action>> = {
  [ItemPermissionType.Owner]: [
    Action.Read,
    Action.Write,
    Action.Delete,
    Action.Share,
    Action.Download
  ],
  [ItemPermissionType.Editor]: [
    Action.Read,
    Action.Write,
    Action.Share,
    Action.Download
  ],
  [ItemPermissionType.Viewer]: [Action.Read, Action.Download],
  [ItemPermissionType.Contributor]: [
    Action.Read,
    Action.Write,
    Action.Download
  ],
  [ItemPermissionType.Guest]: [Action.Read]
}

type RoleInput =
  | ItemPermissionType
  | undefined
  | Array<ItemPermissionType | undefined>

export function canPerformAction(roles: RoleInput, action: Action) {
  if (!roles) {
    return false
  }

  const roleList = Array.isArray(roles) ? roles : [roles]

  if (roleList.some(role => !role)) {
    return false
  }

  return roleList.every(role =>
    permissionToActionsMap[role as ItemPermissionType]?.includes(action)
  )
}

export function getPermissions(roles: RoleInput) {
  return {
    canRead: canPerformAction(roles, Action.Read),
    canWrite: canPerformAction(roles, Action.Write),
    canDelete: canPerformAction(roles, Action.Delete),
    canShare: canPerformAction(roles, Action.Share),
    canDownload: canPerformAction(roles, Action.Download)
  }
}

export const usePermissions = (roles: RoleInput) =>
  useMemo(() => getPermissions(roles), [roles])
